export const serviceCategoriesFor = (services, serviceCategories, { locales }) => {
  if (services.length === 0 || serviceCategories.length === 0) {
    return []
  }

  // Only return categories in use by at least one service
  let categories = serviceCategories.filter(category => {
    return services.some(s =>  s.categories.map(c => c.id).indexOf(category.id) !== -1)
  })

  if (services.some(s => s.categories.length === 0)) {
    categories.push({
      id: "other",
      name: locales['other'],
    })
  }

  return categories
}
